import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';

export const useSvgUploader = () => {
  const { addSvg } = useEditorCanvas();

  const openPicker = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.svg,image/svg+xml';
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;
      await addSvg(await file.text());
    };
    input.click();
  };

  return { openPicker };
};
